import { get } from 'lodash';
import Service from '../../services';

export const getLocationInfo = async params => {
  const response = await Service.isnGet(`/api/projects/location-project${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getListTypeTerm = async params => {
  const response = await Service.isnGet(`/api/filters/get-long-short${params}`, res => res);
  return response;
};

export const getOverview = async params => {
  const response = await Service.isnGet(`/api/projects/overview-project${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getGalleryInfo = async params => {
  const response = await Service.isnGet(`/api/projects/gallery-project${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getVideoInfo = async params => {
  const response = await Service.isnGet(`/api/projects/video-project${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getListOffersProject = async params => {
  const response = await Service.isnGet(`/api/projects/list-offer${params}`, res => res);
  return response;
};

export const getDescriptionFacility = async params => {
  const response = await Service.isnGet(`/api/projects/description-facility${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getSpecialsFacility = async params => {
  const response = await Service.isnGet(`/api/projects/specials-facilities${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getAmenities = async params => {
  const response = await Service.isnGet(`/api/projects/amenities-project${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};
export const getListApartmentProject = async params => {
  const response = await Service.isnGet(`/api/projects/list-apartment${params}`, res => res);
  return response;
};

export const getViewApartmentProject = async params => {
  const response = await Service.isnGet(`/api/projects/types-project${params}`, res => res);
  return response;
};

export const getBannerProject = async params => {
  const response = await Service.isnGet(`/api/projects/banner-project${params}`, res => res);
  return response;
};
